import logo from "../../../res/svg/logo.svg";
import mail from "../../../res/svg/mail.svg";
import instagram from "../../../res/svg/instagram.svg";
import "./header.css";
import phone from "../../../res/svg/phone.svg";
import { useState } from "react";
import { useEffect } from "react";

function Header(){
    return(
        <header>
            <img src = {logo} alt = "logo"></img>
            
            <div className="headerinfo">
                <h6>Контакты: <a href = "tel: +77013201551">+7(701)320-15-51</a></h6>
                <div className="headercontacts">
                    <a href="mailto:qadamtech@gmail.com">
                        <img src = {mail} alt = "email"></img>
                    </a>

                    <a href="https://instagram.com/onde.kz">
                        <img src = {instagram} alt = "instagram"></img>
                    </a>
                </div>

                <a href = "#consult">
                    <button className="simple"><h6>Получить консультацию</h6></button>
                </a>
            </div>

            <a id = "phoneLink" href="tel: +77013201551">
                <img id = "phone" src = {phone} alt = "call"></img>
            </a>
        </header>
    )
}

export default Header;